/**
 * Where a signed-in member lands when nothing else decides it (no remembered
 * deep link, no clinic-entry URL). In order:
 *  - the Dashboard for whoever may open it (`clinic.reports.read`, which
 *    Full Clinic Administrator satisfies like every key) — management;
 *  - the Calendar for whoever schedules across the clinic
 *    (`clinic.bookings.schedule`) — the front desk's primary workspace
 *    (ZOY-712); a therapist who also schedules lands here too, one click from
 *    Today;
 *  - Today for everyone else, exactly as before.
 * No role name is consulted: capability keys only. The same rule sends a
 * direct visit to /reports without the key back to the next landing, so no
 * "access denied" dashboard is ever rendered.
 */

import { PERM, type PermissionKey } from '@/core/authz/permissions';

export type Landing = '/reports' | '/calendar' | '/today';

export const canOpenDashboard = (can: (key: PermissionKey) => boolean): boolean =>
  can(PERM.reportsRead);

export const landingFor = (can: (key: PermissionKey) => boolean): Landing =>
  canOpenDashboard(can) ? '/reports' : can(PERM.bookingsSchedule) ? '/calendar' : '/today';
